import React from "react";

const MobileNavDrawer = () => (
  <div className="nav-mobile-drawer" id="navMobileDrawer" aria-hidden="true">
    <button
      type="button"
      className="nav-mobile-backdrop"
      id="navMobileBackdrop"
      aria-label="Close menu"
    />
    <aside className="nav-mobile-panel" role="dialog" aria-modal="true" aria-label="Site menu">
      <div className="nav-mobile-top">
        <button type="button" className="nav-mobile-close" id="navMobileClose" aria-label="Close menu">
          <span className="nav-mobile-close-icon" aria-hidden="true">
            ×
          </span>
        </button>
      </div>
      <div className="nav-mobile-body">
        <nav className="nav-mobile-nav" aria-label="Mobile navigation">
          <a href="#about" className="nav-mobile-link">
            Vision
          </a>
          <a href="#models" className="nav-mobile-link">
            Products
          </a>
          <a href="#mai" className="nav-mobile-link">
            Technology
          </a>
          <a href="#intelligence" className="nav-mobile-link">
            Impact
          </a>
          <a href="#contact" className="nav-mobile-link">
            Contact
          </a>
          <a href="#" className="nav-mobile-cta" data-login-link="true">
            Login / Sign Up
          </a>
        </nav>
      </div>
    </aside>
  </div>
);

export default MobileNavDrawer;
